import React from 'react';

const PaymentMethodPage = () => (
  <div>
    VISA or MASTERCARD
  </div>
);

export default PaymentMethodPage;
